import { FC } from 'react'
import { FormProvider, useForm } from 'react-hook-form'

import { zodResolver } from '@hookform/resolvers/zod'

import { PickupDeliveryLocationResponseV1 } from '@forto-dev/customer-master-data-models'
import {
  Button,
  Dialog,
  DialogBody,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@forto-dev/phoenix-ui-core'

import { useLocalisation } from '@/utils/localisation'

import { LocationForm } from './LocationForm'
import { LocationFormData, locationFormDataSchema } from '../../schema'
import { mapPickupDeliveryLocationResponseToAddressFormData } from '../../utils/locationFormMapper'

type LocationViewDialogProps = {
  onClose: () => void
  pickupDeliveryLocation: PickupDeliveryLocationResponseV1
  title?: string
  description?: string
}

export const LocationViewDialog: FC<LocationViewDialogProps> = (props) => {
  const { translate } = useLocalisation()

  const { onClose, pickupDeliveryLocation, title = translate(`locations.view.title`) } = props

  const selectedValue = {
    address: mapPickupDeliveryLocationResponseToAddressFormData(pickupDeliveryLocation),
    localAddress: null,
    companyName: pickupDeliveryLocation.address?.companyName || '',
    locationName: pickupDeliveryLocation.locationName,
    notes: pickupDeliveryLocation.notes || undefined,
    contact: pickupDeliveryLocation.contactIDs || [],
    unLocode: pickupDeliveryLocation.unLocode ?? '',
  }

  const formMethods = useForm<LocationFormData>({
    defaultValues: selectedValue,
    resolver: zodResolver(locationFormDataSchema),
  })

  return (
    <Dialog
      defaultOpen
      onOpenChange={(isOpen) => {
        if (!isOpen) {
          onClose()
        }
      }}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <FormProvider {...formMethods}>
            <fieldset disabled={true}>
              <LocationForm />
            </fieldset>
          </FormProvider>
        </DialogBody>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline-primary">{translate('actions.cancel')}</Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
